<template>
  <div class="bg-white br-15">
    <div class="container-login container-login-img">
      <form-wrapper :validator="$v.user">
        <main id="main-container" class="bg-white body login-layout">
          <!-- Page Content -->
          <div class="hero-static d-flex align-items-center ">
            <!-- Sign In Section -->

            <div class="content content-full">
              <div class="row justify-content-center">
                <div class="col-md-12 col-lg-12 col-xl-12">
                  <!-- Header -->
                  <div class="text-center">
                    <!-- <p class="mb-2">
                    <i class="fa fa-2x fa-circle-notch text-primary"></i>
                  </p> -->
                    <!-- <h1
                      class="h4 mt-0 font-poppins font-weight-bold txt-2"
                      style="color: #00897B"
                    >
                      Sign In
                    </h1> -->
                  </div>
                  <!-- END Header -->

                  <div class="main back-white">
                    <div
                      class="alert alert-danger "
                      v-if="failed"
                      style="padding: 6px;margin: 4px;"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        class="bi bi-exclamation-triangle-fill flex-shrink-0 me-2"
                        viewBox="0 0 16 16"
                        role="img"
                        aria-label="Warning:"
                      >
                        <path
                          d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
                        />
                      </svg>

                      Incorrect username or password!.
                    </div>

                    <div class="py-3">
                      <div class="form-group">
                        <BaseInput
                          class="input-100 input-101"
                          v-model="user.username"
                          type="text"
                          id="login-username"
                          name="login-username"
                          placeholder="Username"
                          @onEnter="Login()"
                        />
                      </div>
                      <div class="form-group">
                        <BaseInput
                          class="input-100 input-101"
                          v-model="user.password"
                          type="password"
                          id="login-password"
                          name="login-password"
                          placeholder="Password"
                          @onEnter="Login()"
                        />
                      </div>
                      <div class="form-group">
                        <div
                          class="d-md-flex align-items-md-center justify-content-md-between"
                        >
                          <!-- <div class="custom-control custom-switch">-
                              <input
                                type="checkbox"
                                class="custom-control-input"
                                id="login-remember"
                                name="login-remember"
                              />
                              <label
                                class="custom-control-label font-w400"
                                for="login-remember"
                                >Remember Me</label
                              >
                            </div> -->
                          <!-- <div class="py-2">
                          <a class="font-size-sm" href="op_auth_reminder2.html"
                            >Forgot Password?</a
                          >
                        </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="form-group row justify-content-center mb-0">
                      <div class="col-md-8 col-xl-8">
                        <b-button
                          variant="warning"
                          type="submit"
                          class="btn btn-block btn-primary txt-1"
                          @click="Login()"
                        >
                          <b-spinner
                            v-if="loading"
                            type="border"
                            small
                          ></b-spinner>
                          <div v-else>
                            <i class="fa fa-fw fa-sign-in mr-1"></i>
                            Login
                          </div>
                        </b-button>
                      </div>
                    </div>
                  </div>
                  <!-- END Sign In Form -->
                </div>
              </div>
            </div>
          </div>
          <!-- END Sign In Section -->

          <!-- Footer -->
          <div class="font-size-s2 m text-center text-muted py-3 txt-1">
            <strong>Speed Code Labs</strong> &copy;
            <span data-toggle="year-copy"></span>

            <!-- END Footer -->
          </div>
          <!-- END Page Content -->
        </main>
      </form-wrapper>
    </div>
  </div>
</template>
<script>
import BaseInput from "@/components/base/Input";
import { required } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import axios from "@/plugins/axios";
export default {
  name: "Login",
  layout: "none",
  components: {
    BaseInput,
  },
  data: () => ({
    failed: false,
    loading: false,
    loginerror: "",
    user: {
      username: "",
      password: "",
    },
  }),
  mounted: function() {
    if (this.status) {
      this.$router.push("/");
    }
  },
  computed: {
    ...mapState("auth", ["status"]),
  },
  methods: {
    async Login() {
      this.loading = true;
      this.failed = false;
      this.$v.$touch(); //it will validate all fields
      if (!this.$v.$invalid) {
        //invalid, becomes true when a validations return false
        // this.$store
        //   .dispatch("auth/Login", this.user)
        //   .then(res => {
        //     if (res.status == 200) {
        //       this.loading = false;
        //       this.$router.push("/");
        //     }
        //   })
        //   .catch(err => {});
        // this.loading = true;
        // setTimeout(() => {
        //   this.loading = false;
        //   this.$router.push("/");
        // }, 3000);
        this.$store
          .dispatch("auth/Login", this.user)
          .then((res) => {
            // this.$store.dispatch("masterData/FetchAllShortCuts");
            this.$store.commit("bill/CANCEL_BILL");
            setTimeout(() => {
              this.$router.push("/");
            }, 700);
          })
          .catch((err) => {
            this.loading = false;
            this.failed = true;
          });

        // var response = await this.$auth.login({ data: this.user });
        // if (response.status == 200) {
        //   this.$auth.setUserToken(response.data.accessToken);
        //   this.$axios.setToken(response.data.accessToken, "Bearer");
        //   this.loading = false;

        //   this.$router.push("/");
        // } else {
        //   console.log("Login Failed");
        //   this.loading = false;
        // }
      } else {
        this.loading = false;
      }
    },
  },
  validations: {
    user: {
      username: { required },
      password: { required },
    },
  },
};
</script>

<style>
.input-101 {
  width: 250px;
}

.txt-1 {
  margin-top: -20px;
}

.txt-2 {
  margin-top: -40px !important;
  margin-bottom: -9px;
}

.input-100 {
  max-width: 400px;
  margin-top: 30px;
}
.login-layout {
  margin-top: 300px;
  margin-left: 100px;
  background-color: transparent !important;
}
.login-form {
  width: 50%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: wrap;
  /* padding: 255px 52px; */
  padding: 170px 48px;
}
.login-more {
  width: 50%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  position: relative;
  z-index: 1;
}

.wrap-login {
  border-radius: 20px;
  width: 890px;
  background: #fff;
  overflow: hidden;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  flex-direction: row-reverse;
}
.limiter {
  width: 100%;
  margin: 0 auto;
}

.container-login {
  width: 100%;
  min-height: 100vh;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;

  padding: 15px;
}

.container-login-img {
  background: url("../../src/assets/background2.png");
  background-size: cover !important;
}
.login-form * {
  margin: 0px;
  padding: 0px;
  box-sizing: border-box;
}
.br-15 {
  border-radius: 15px;
}

.loginerror {
  color: chocolate;

  background: fixed;
}
</style>
